"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var style_utils_1 = require("@nef/style-utils");
var Box_1 = __importDefault(require("../../../Box"));
var SidebarButtonContent_1 = __importDefault(require("../../../components/SidebarButtonContent"));
var SidebarWideButtonText_1 = __importDefault(require("../../../components/SidebarWideButtonText"));
var FontAwesomeIcon_1 = __importDefault(require("../../../FontAwesomeIcon"));
var Sidebar_1 = require("../../../Sidebar");
var SidebarButtonSubButtons = function (_a) {
    var active = _a.active, className = _a.className, isOpen = _a.isOpen, subButtons = _a.subButtons, props = __rest(_a, ["active", "className", "isOpen", "subButtons"]);
    var _b = react_1.default.useContext(Sidebar_1.SidebarContext), expanded = _b.expanded, rtl = _b.rtl;
    if (isOpen && expanded && subButtons) {
        return (react_1.default.createElement("div", { className: "sidebar-toggle-button--sub-button-container" }, subButtons.map(function (_a, idx) {
            var sbActive = _a.active, children = _a.children, disabled = _a.disabled, iconClassName = _a.iconClassName, iconSetClassName = _a.iconSetClassName, onClick = _a.onClick, sb = __rest(_a, ["active", "children", "disabled", "iconClassName", "iconSetClassName", "onClick"]);
            var key = "sub-button-" + idx;
            var margin = iconClassName ? 5 : 4;
            return (react_1.default.createElement(SidebarButtonContent_1.default, __assign({}, props, sb, { key: key, className: style_utils_1.classNames("sidebar-toggle-button--sub-button", className), activeSubButton: sbActive, disabled: disabled, lastItem: idx + 1 === subButtons.length, onClick: !disabled ? onClick : undefined, onKeyDown: !disabled ? onClick : undefined }),
                react_1.default.createElement(Box_1.default, { className: "sidebar--toggle-button--icon-container", marginLeft: !rtl ? margin : "none", marginRight: rtl ? margin : "none" },
                    react_1.default.createElement(FontAwesomeIcon_1.default, { className: "sidebar--toggle-button--icon", iconClassName: iconClassName, iconSetClassName: iconSetClassName })),
                react_1.default.createElement(SidebarWideButtonText_1.default, null, children)));
        })));
    }
    return null;
};
exports.default = SidebarButtonSubButtons;
//# sourceMappingURL=index.js.map